import { useMemo } from "react";
import FirmFlowTable from "../../../../components/mytasks/FirmFlowTable"; // Adjust the import path as necessary
import { buildWorkloadDrilldownHref } from "../workloadDrilldownUtils";

const WorkloadReportByDepartments = ({ data, appliedFilters }) => {
    const columns = useMemo(
        () => [
            {
                Header: "Department",
                accessor: "departmentName",
                Cell: (props) => props.value,
            },
            {
                Header: "Teams",
                accessor: "teams",
                Cell: (props) => {
                    return props.value.length > 0
                        ? props.value.map((team) => (
                              <ul key={team.teamId}>
                                  <li className="list-disc">{team.teamName}</li>
                              </ul>
                          ))
                        : "No Teams";
                },
            },
            {
                Header: "Total Clients",
                accessor: "totalClients",
                Cell: (props) => {
                    return (
                        <a
                            href={buildWorkloadDrilldownHref(
                                appliedFilters,
                                {
                                    departmentId:
                                        props.row.original.departmentId,
                                },
                            )}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-500 hover:underline"
                        >
                            {props.value}
                        </a>
                    );
                },
            },
        ],
        [appliedFilters]
    );
    const resetSignal = appliedFilters;

    return (
        <div>
            <FirmFlowTable
                columns={columns}
                data={data}
                resetPageSignal={resetSignal}
                resetSearchSignal={resetSignal}
            />
        </div>
    );
};

export default WorkloadReportByDepartments;
